RivalIQ.apps.Shell.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Sections = Marionette.CompositeView.extend({
        template: '#shellSidebarSectionsTemplate',

        events: {
            'click .x-contact-us': 'showContactUs'
        },

        childViewContainer: 'nav.panel-group',
        childView: views.Section,
        attributes: {
            role: 'navigation'
        },

        childViewOptions: function (model) {
            const items = model.get('items') || [];
            const collection = new Backbone.Collection(items);

            return _.extend({
                model: model,
                collection: collection
            }, _.pick(model.toJSON(), 'viewStateEvents', 'landscapeStateEvents'));
        },

        filter: function (item) {
            const model = item.toJSON();
            return (_.isUndefined(model.display) || _.result(model, 'display'));
        },

        initialize: function () {
            const me = this;
            me.listenTo(RivalIQ.state.landscape, 'change:activeSources', me.render);
        },

        showContactUs: function () {
            RivalIQ.execute('show:modal', new RivalIQ.apps.Shell.views.ContactUsModal({
                model: new Backbone.Model({
                    context: 'Sidebar',
                    modalDescription: RivalIQ.state.plan.get('has_quid_compete_branding') ? RivalIQ.strings.notification_contact_description_quid : RivalIQ.strings.notification_contact_description
                })
            }));
        }
    });

});
